import { memo, useEffect } from 'react';
import { HoxRoot } from 'hox';
import QuestionAnswer from './exports/qa';
import QuestionDetail from './exports/qa-detail';
import KnowledgePointsDetail from './exports/knowledge-points-detail';
import Equity from './exports/equity';
import MyQuestion from './exports/my-question';
import RechargeRecord from './exports/recharge-record';
import Photo from './exports/photo';
import Video from './exports/video';
import SimilarSearch from './exports/similar-search';
import MyCollect from './exports/my-collect';
import { handleTokenExample, navigateExample } from './utils/class-example';
import { ISubLucaPluginProps } from '@/sub-luca-plugin/types/index';
import { I18nInitializer } from '@/sub-luca-plugin/components/i18n/I18nInitializer';
import './index.scss';

const SubLucaPlugins = ({ type, initParams = {}, getAccessTokenFn, getHttpConfigFn, navigateFn, linkToLoginPage }: ISubLucaPluginProps) => {
    // 判断条件 需要设置getAccessToken。 getAccessToken 从父级组件传入
    if (getAccessTokenFn && !handleTokenExample.getTokenFn) {
        handleTokenExample.setGetTokenFn(getAccessTokenFn);
    }

    if (getHttpConfigFn && !handleTokenExample.getHttpConfigFn) {
        handleTokenExample.setGetHttpConfigFn(getHttpConfigFn);
    }

    useEffect(() => {
        // console.log('initParams', initParams);
        // 小程序接收传参
        navigateFn && navigateExample.setLinkTo(navigateFn);
        linkToLoginPage && handleTokenExample.setLinkToLoginPage(linkToLoginPage);
    }, []);

    switch (type) {
        case 'qa':
            return (
                <HoxRoot>
                    <QuestionAnswer initParams={initParams} />
                </HoxRoot>
            );
        case 'gbot_detail':
        case 'qa_pair_detail':
            return <QuestionDetail {...initParams} onClose={() => navigateFn?.('back')} />;
        case 'knowledge_points_detail':
            return <KnowledgePointsDetail {...initParams} />;
        case 'equity':
            return (
                <Equity
                    orderBackUrl={initParams.orderBackUrl}
                    orderSource={initParams.orderSource}
                    projectId={initParams.projectId}
                    lucaId={initParams.lucaId}
                />
            );
        case 'recharge_record':
            return <RechargeRecord projectId={initParams.projectId} />;
        case 'my_question':
            return <MyQuestion {...initParams} />;
        case 'photo':
            return <Photo {...initParams} />;
        case 'video':
            return <Video {...initParams} />;
        case 'similar_search':
            return <SimilarSearch {...initParams} />;
        case 'my_collect':
            return <MyCollect {...initParams} />;
        default:
            return null;
    }
};

/**
 * 插件包装器组件
 * 提供国际化初始化功能
 */
function SubLucaPluginsI18nWrapper(props: ISubLucaPluginProps) {
    return (
        <I18nInitializer>
            <SubLucaPlugins {...props} />
        </I18nInitializer>
    );
}

export default memo(SubLucaPluginsI18nWrapper);
